export const findSpaces = (value: string) => value.trim().indexOf(' ') !== -1;
